<div *ngIf="loadTestComplete" class="shr-login" fxLayout="column">
    <div [style.backgroundColor]="backgroundColor" class="header" fxLayout="column" fxLayoutAlign="end center">
        <div fxLayout="row" fxLayoutAlign="center end" class="title">
            <img [src]="'./assets/logo.png'" />
            <div *ngIf="showBaseTitle">{{configurationService.baseTitle}}</div>
        </div>
    </div>
    <div class="content" fxLayout="column" fxLayoutAlign="start center">
        <div style="margin-top: 50px;" *ngIf="safeCountCompatible">
            <a style="font-size: 28px;" href="/safecount/">Goto SafeCount</a>
        </div>
        <mat-card class="details">
            <mat-card-content fxLayout="column" fxLayoutAlign="start stretch">
                <form name="login" fxLayout="column" fxLayoutAlign="start stretch">
                    <mat-form-field class="input">
                        <mat-icon matPrefix>lock</mat-icon>
                        <input name="username" (keydown)="onKeyDown($event)" matInput [(ngModel)]="loginModel.userName"
                            alt="User name" placeholder="User name" type="text">
                    </mat-form-field>
                    <mat-form-field class="input">
                        <mat-icon matPrefix>person</mat-icon>
                        <input name="password" (keydown)="onKeyDown($event)" matInput [(ngModel)]="loginModel.password"
                            alt="Password" placeholder="Password" type="password">
                    </mat-form-field>
                </form>
                <span class="error">{{ error }} </span>
            </mat-card-content>
            <mat-card-actions fxLayout="column">
                <shr-progress-button-spinner raised="true" diameter="30" text="Log in" mode="indeterminate"
                    [active]="loginProcess.isRunning == true" (shrClick)="login()" color="primary">
                </shr-progress-button-spinner>
            </mat-card-actions>
        </mat-card>
    </div>
</div>
